export class UserListStateModel {
    users!: {};
    activePage!: number;
    filterResult!: {};
}